import { FormHelperText, Stack } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useController, useFormContext } from 'react-hook-form'

import ToggleButtonGroup, { type ToggleButtonGroupProps } from './ToggleButtonGroup'

export const DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const
export type DayOfWeek = (typeof DAYS_OF_WEEK)[number]

/**
 * This is a utility to set default values for the days of week input
 */
export const allDaysOfWeek: DayOfWeek[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']

type DaysOfWeekInputProps = Omit<ToggleButtonGroupProps, 'buttons'>

export default function DaysOfWeekInput(props: DaysOfWeekInputProps) {
  const t = useTranslations('settings.products')
  const { control } = useFormContext()
  const { fieldState } = useController({ name: props.name, control })

  const fieldError = fieldState.error?.message
  return (
    <Stack>
      <ToggleButtonGroup
        {...props}
        buttons={DAYS_OF_WEEK.map((day) => ({ value: day, label: t(`DaysOfWeekInput_days_${day}`) }))}
        slotProps={{
          toggleButtonGroup: {
            fullWidth: true
          }
        }}
      />
      {fieldError && <FormHelperText error>{fieldError}</FormHelperText>}
    </Stack>
  )
}
